import { render, staticRenderFns } from "./page-internal-nav.component.vue?vue&type=template&id=750795d4&"
import script from "./page-internal-nav.component.vue?vue&type=script&lang=ts&"
export * from "./page-internal-nav.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports